export default __webpack_public_path__ + "static/media/redireccionamiento.7b00f663.svg";